import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useAppSelector } from './useAppSelector';

export const PROJECT_REQUESTS_QUERY_KEY = ['apis.v1.project-requests'];

export function useProjectRequestsQuery() {
    const userId = useAppSelector((state) => state.auth.user?.id);

    const { data, isPending, isError, refetch } = useQuery({
        queryKey: [...PROJECT_REQUESTS_QUERY_KEY, userId],
        queryFn: Endpoints.v1.Projects.listProjectRequests,
        enabled: userId !== undefined,
        staleTime: 30_000,
        refetchInterval: 60_000,
        refetchOnWindowFocus: true,
    });

    const pendingCount =
        (data?.invitations?.length ?? 0) +
        (data?.payerRequests?.length ?? 0) +
        (data?.ownershipOffers?.length ?? 0);

    return { data, pendingCount, isPending, isError, refetch };
}
